/**
 * cookie api封装：
 * set(key:string, value:any, delay?:string)
 * get(key?:string)
 * del(key:string)
 **/
abstract class TsCookie {
    abstract set(key: string, value: any, delay?: string): string | boolean;
    abstract get(key?: string): any;
    abstract del(key: string): boolean | string;
}

export default class Cookie implements TsCookie {
    set(key: string, value: any, delay?: string): string | boolean {
        //默认cookie为七天之后过期 3s 4m 5h 7d 秒 分 时 天
        if (delay == "undefined") delay = "7d";

        delay = (delay || "7d").toLowerCase();

        var expireDate: any = new Date();

        var num = parseInt(delay);
        if (delay.indexOf("d") !== -1) {
            expireDate.setDate(expireDate.getDate() + num);
        } else if (delay.indexOf("h") !== -1) {
            expireDate.setHours(expireDate.getHours() + num);
        } else if (delay.indexOf("m") !== -1) {
            expireDate.setMinutes(expireDate.getMinutes() + num);
        } else if (delay.indexOf("s") !== -1) {
            expireDate.setSeconds(expireDate.getSeconds() + num);
        } else {
            expireDate.setDate(expireDate.getDate() + num);
        }
        if (typeof value == "object") {
            value = JSON.stringify(value);
        }

        value = encodeURIComponent(value);

        document.cookie =
            key + "=" + value + ";expires=" + expireDate.toGMTString();
        return this.get(key);
    }

    get(key?: string) {
        var objCookie: any = {};
        var cookie = document.cookie;
        var keyValueList = cookie.split(";");
        for (var index in keyValueList) {
            var keyValue = keyValueList[index].split("=");
            var k = keyValue[0].trim();
            var v = keyValue[1];
            v = decodeURIComponent(v);
            v = this.decodeJson(v);
            objCookie[k] = v;
        }

        if (typeof key == "undefined") {
            return objCookie;
        }

        return objCookie[key];
    }

    del(key?: string): boolean | string {
        //删除所有cookie
        if (typeof key == "undefined") {
            var cookieList = this.get();
            for (key in cookieList) {
                this.del(key);
            }
            return true;
        } else {
            if (this.get(key) == "undefined") {
                return false;
            } else {
                return this.set(key, "", "0s");
            }
        }
    }

    decodeJson(value: string): string {
        //数组转成的对象字符串
        var regAryStr = /^\[[\s|\S]*\]$/;
        //对象转成的对象字符串
        var regObjStr = /^\{([\"\s|\S]+\"\:\"[\s|\S]*)+\"\}$/;
        if (regAryStr.test(value)) {
            return eval("(" + value + ")");
        }
        if (regObjStr.test(value)) {
            return JSON.parse(value);
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/common/ts/cookie.ts